import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MapSelection } from '../map.selection';
import { MapLayer } from '../models/map.model';
import { LayerItemNode } from '../models/legend.model';
import { MapService } from './map.service';

declare var ol: any;

@Injectable()
export class LegendService {
  dataChange = new BehaviorSubject<LayerItemNode[]>([]);
  mapLoaded = new Subject<MapSelection>();

  get data(): LayerItemNode[] {
    return this.dataChange.value;
  }

  constructor(private mapService: MapService) {
    this.mapService.onMapLoaded().subscribe((mapSelection) => {
      this.buildLegendDataFromMap(mapSelection?.getMap());
      this.mapLoaded.next(mapSelection);
    });
  }

  buildLegendDataFromMap(map: any) {
    const nullNode = new LayerItemNode();
    nullNode.key = '---';

    let items: LayerItemNode[] = [];

    if (map == null) items = [nullNode];
    else {
      const mapLayers = map.getLayers().getArray();
      let cnt: number = mapLayers.length;

      for (let i = 0; i < cnt; i++) {
        const l = mapLayers[i];
        if (l.layerdefinition?.visibleInLegend !== false) {
          const n: LayerItemNode = this.createNodeFromLayer(l, null);
          items.push(n);
        }
      }
    }

    this.dataChange.next(items);
  }

  createNodeFromLayer(l: any, parentKey: string): LayerItemNode {
    let name = l.get('title');
    if (name === undefined) name = l.get('name');

    if (name === undefined) name = '<<?>>';

    const n = new LayerItemNode();
    if (parentKey) {
      n.key = parentKey + '|' + name;
    } else {
      n.key = name;
    }
    n.displayText = name;
    n.layer = l;
    n.collapsedByDefault = l.layerdefinition?.collapsedByDefault;

    if (l instanceof ol.layer.Group) {
      const subLayers = l.getLayers().getArray();
      const cnt: number = subLayers.length;

      for (let j = 0; j < cnt; j++) {
        const ll = subLayers[j];
        if (ll.layerdefinition?.visibleInLegend !== false) {
          const m: LayerItemNode = this.createNodeFromLayer(ll, n.key);

          let subNodes = n.children;

          if (subNodes == undefined) {
            subNodes = [];
            n.children = subNodes;
          }

          n.children.push(m);
        }
      }
      if (n.children?.find((_) => _.children?.find((c) => c.style))) {
        for (const sub of n.children) {
          if (!sub.children) {
            sub.children = [];
          }
        }
      }
    } else if (
      (l.layerdefinition as MapLayer)?.style?.find((s) => s.displayText !== undefined && s.displayText !== null)
    ) {
      n.children = [];
      for (const s of (l.layerdefinition as MapLayer)?.style) {
        const nstyle = new LayerItemNode();
        nstyle.key = n.key + '$' + s.displayText + '$' + s.partition;
        nstyle.displayText = s.displayText;
        nstyle.style = s;
        n.children.push(nstyle);
      }
    }

    return n;
  }
}
